import React, {useRef, useEffect, useState} from "react";
import {Canvas, useFrame, useThree, extend} from "react-three-fiber";

import ItinerarisControls from "./ItinierarisControls";
import Imatges from "./Imatges"
import Instruccions from "./Instruccions";
import Titol from "./Titol";

import './App.css';

extend({ItinerarisControls});

const CameraControls = () => {
	// Get a reference to the Three.js Camera, and the canvas html element.
	// We need these to setup the OrbitControls component.
	// https://threejs.org/docs/#examples/en/controls/OrbitControls

	const {
		camera,
		gl: {domElement},
	} = useThree();
	// Ref to the controls, so that we can update them on every frame using useFrame

	const controls = useRef();

	useEffect(() => {
		if (controls && controls.current) {
			controls.current.enableDamping = true;
			controls.current.listenToKeyEvents(window);
		}
	}, [controls])


	useFrame((state) => {
		controls.current.update();
	});

	return <itinerarisControls ref={controls} args={[camera, domElement]}/>;
}

function App() {
	const [titolVisible, setTitolVisible] = useState(false);

	const showTitle = () => {
		setTitolVisible(true);
	}

	return (
		<>
			<Instruccions onClose={showTitle} />
			<Canvas>
				<ambientLight />
				<CameraControls/>
				<fogExp2 attach="fog" args={['#ffffff', 0.075]}/>
				<Imatges position={[0, 0, 0]}/>
				<Titol visible={titolVisible}/>
			</Canvas>
		</>
	);
}

export default App;
